import { ArrowLeft, Bell, History, House, Trophy, Wallet, WalletCards } from "lucide-react";
import { useSite } from "../../lib/site";
import { fileUrl } from "../../lib/api";

export const Logo = () => {
  const { site } = useSite();
  const name = site.site_name || "Laxmiwin";
  return <div className="logo-mark" data-testid="brand-logo"><img className="logo-img" src={site.logo_url ? fileUrl(site.logo_url) : "/assets/logo.png"} alt={name} /></div>;
};

export const Header = ({ title, onBack, onBell }) => (
  <header className="page-header">
    {onBack && <button onClick={onBack} data-testid="page-back-button"><ArrowLeft /></button>}
    <Logo /><span>{title}</span>
    <button onClick={onBell} data-testid="notifications-button"><Bell /></button>
  </header>
);

const NAV = [["home", "Home", House, "home-nav-button"], ["history", "Activity", History, "activity-nav-button"]];
const NAV2 = [["deposit", "Wallet", Wallet, "wallet-nav-button"], ["account", "Account", WalletCards, "account-nav-button"]];

export const BottomNav = ({ page, setPage }) => {
  const item = ([p, label, Icon, id]) => <button key={p} onClick={() => setPage(p)} className={page === p ? "active" : ""} data-testid={id}><Icon />{label}</button>;
  return (
    <nav className="bottom-nav">
      {NAV.map(item)}
      <button className="bonus-float" onClick={() => setPage("deposit")} data-testid="bonus-button"><Trophy /><b>Get ₹500</b></button>
      {NAV2.map(item)}
    </nav>
  );
};
